module.exports = __webpack_public_path__ + "img/v41.fde52ced.jpg";